export function keyStages() {
    const keyStageItems = document.querySelectorAll('.site-activity__key-stages-item');

    const openKeyStage = (keyStageItem) => {
        const content = keyStageItem.querySelector('.site-activity__key-stages-item__content');
        keyStageItem.classList.add('site-activity__key-stages-item--active');
        content.style.maxHeight = content.scrollHeight + 'px';
    };

    const closeKeyStage = (keyStageItem) => {
        const content = keyStageItem.querySelector('.site-activity__key-stages-item__content');
        keyStageItem.classList.remove('site-activity__key-stages-item--active');
        content.style.maxHeight = null;
    };

    keyStageItems.forEach((keyStageItem) => {
        const title = keyStageItem.querySelector('.site-activity__key-stages-item__title');
        const content = keyStageItem.querySelector('.site-activity__key-stages-item__content');

        title.onclick = () => {
            if (content.style.maxHeight) {
                closeKeyStage(keyStageItem);
            } else {
                keyStageItems.forEach((item) => closeKeyStage(item));
                openKeyStage(keyStageItem);
            }
        };
    });
}
